export default __webpack_public_path__ + "static/media/gathering.d533e821.jpg";